import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import "./Auth.css";

const Signup = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_URL || "http://localhost:3337";

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post(`${API_URL}/api/users/signup`, data);
      localStorage.setItem("token", response.data.token);
      navigate("/login");
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Erreur lors de l'inscription."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-card--wide">
        {/* Logo */}
        <div className="auth-card__logo">
          <img src="/bouchaddakh-logo.png" alt="BOUCHADDAKH" />
        </div>

        {/* Header */}
        <div className="auth-card__header">
          <h1 className="auth-card__title">Créer un compte</h1>
          <p className="auth-card__subtitle">
            Rejoignez BOUCHADDAKH et accédez à nos services
          </p>
        </div>

        {/* Error */}
        {errorMessage && (
          <div className="auth-alert auth-alert--error">{errorMessage}</div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="auth-form__row">
            <div className="auth-field">
              <label className="auth-field__label">Nom</label>
              <input
                type="text"
                className={`auth-field__input ${errors.nom ? "auth-field__input--error" : ""}`}
                placeholder="Votre nom"
                {...register("nom", { required: "Nom requis" })}
              />
              {errors.nom && (
                <p className="auth-field__error">{errors.nom.message}</p>
              )}
            </div>

            <div className="auth-field">
              <label className="auth-field__label">Prénom</label>
              <input
                type="text"
                className={`auth-field__input ${errors.prenom ? "auth-field__input--error" : ""}`}
                placeholder="Votre prénom"
                {...register("prenom", { required: "Prénom requis" })}
              />
              {errors.prenom && (
                <p className="auth-field__error">{errors.prenom.message}</p>
              )}
            </div>
          </div>

          <div className="auth-form__row">
            <div className="auth-field">
              <label className="auth-field__label">Email</label>
              <input
                type="email"
                className={`auth-field__input ${errors.email ? "auth-field__input--error" : ""}`}
                placeholder="votre@email.com"
                {...register("email", {
                  required: "Email requis",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Email invalide",
                  },
                })}
              />
              {errors.email && (
                <p className="auth-field__error">{errors.email.message}</p>
              )}
            </div>

            <div className="auth-field">
              <label className="auth-field__label">Téléphone</label>
              <input
                type="text"
                className={`auth-field__input ${errors.tel ? "auth-field__input--error" : ""}`}
                placeholder="Votre numéro"
                {...register("tel", {
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Numéro invalide",
                  },
                })}
              />
              {errors.tel && (
                <p className="auth-field__error">{errors.tel.message}</p>
              )}
            </div>
          </div>

          <div className="auth-field">
            <label className="auth-field__label">Société</label>
            <input
              type="text"
              className={`auth-field__input ${errors.societe ? "auth-field__input--error" : ""}`}
              placeholder="Nom de votre société"
              {...register("societe", { required: "Nom de société requis" })}
            />
            {errors.societe && (
              <p className="auth-field__error">{errors.societe.message}</p>
            )}
          </div>

          <div className="auth-field">
            <label className="auth-field__label">Mot de passe</label>
            <input
              type="password"
              className={`auth-field__input ${errors.password ? "auth-field__input--error" : ""}`}
              placeholder="Minimum 6 caractères"
              {...register("password", {
                required: "Mot de passe requis",
                minLength: {
                  value: 6,
                  message: "Au moins 6 caractères",
                },
              })}
            />
            {errors.password && (
              <p className="auth-field__error">{errors.password.message}</p>
            )}
          </div>

          <button
            type="submit"
            className="auth-submit auth-submit--signup"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="auth-spinner" />
                Inscription...
              </>
            ) : (
              "S'inscrire →"
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="auth-card__footer">
          <span>Déjà inscrit ? </span>
          <Link to="/login">Se connecter</Link>
        </div>
      </div>
    </div>
  );
};

export default Signup;
